export default "__VITE_ASSET__$UduJx7h__"